export const PASSWORD_RECOVERY_COPY = {
  brand: 'Bridge',
  leftBadge: 'Security Protocol',
  otpTitle: 'Verify your identity.',
  otpSubtitle:
    "We've sent a 6-digit verification code to your registered device. Enter the code to bridge into your secure workspace.",
  trustScoreLabel: 'Trust Score',
  trustScoreValue: 85,
  otpCardTitle: 'Enter OTP',
  otpCardSubtitle: 'Check your mobile for the verification code.',
  emailLabel: 'Official Email ID',
  emailPlaceholder: 'e.g., name@bridge.com',
  otpVerifyCta: 'Verify OTP',
  resendLabel: "Didn't receive the code?",
  resendCta: 'Resend Code',
  resetTitle: 'Establish your Anchor.',
  resetSubtitle:
    'Welcome to the Bridge Architectural System. For security compliance, you must rotate your temporary credentials before accessing the dashboard.',
  resetProgressLabel: 'Security Protocol',
  resetProgressStep: 'Step 1 of 1',
  resetCurrentPasswordLabel: 'Current Password (temp)',
  resetNewPasswordLabel: 'New Password',
  resetConfirmPasswordLabel: 'Confirm New Password',
  resetSubmitCta: 'Update Password and Login',
}

export const PASSWORD_RECOVERY_FOOTER_LINKS = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Service', href: '#' },
  { label: 'Security Whitepaper', href: '#' },
  { label: 'Help Center', href: '#' },
]

export const OTP_BACKGROUND_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuDuVtRGJ2WMQGI30E3GfVR0l6rG4c1UJW2tw67fVeLsEWlgXD5Pk-BfK-JkWTD7BgaGU4XXQ3VsURfofUxAdwAs47WJ3KyD430hjahKf9THfRIpc2bTvrT8qPiowhSxYnOmxvZ_la0e-IEjbdMl2jUizeceEZebJt6QI0oktzxrwgyM6RwV1cYqexpvVWOCPzNudNX0CCVoxN7iDTpN2SMLu510xid-6J7qlipITkiPlP1YjJG-3ZmV6sfq1SHA1KmZx90_HgbUOuA'

